import {reactive} from "vue";

export function useOrderStatus() {
  const statusMap = {
    all: "Все заказы",
    planned: "Запланирован",
    driving_to_load: "Ожидает погрузку",
    started_loading: "На погрузке",
    finished_loading: "В пути",
    is_delivered: "Доставлен"
  };

  const getStatusText = (status) => {
    return statusMap[status] || status || "";
  };

  const getOrderStatusColor = (status) => {
    if (status === 'is_delivered') {
      return reactive({color: "#00BF53"});
    } else {
      return reactive({color: "#4d5460"});
    }
  };

  return {
    statusMap,
    getStatusText,
    getOrderStatusColor
  };
}